import { ReactNode } from 'react'

import { routes } from 'commons/constants/routes'
import { Link } from 'ui/components/Link'
import { TableColumn } from 'ui/components/Table'
import { AdverseMediaDetailsType } from '~bank-adverse-media/types'

// TODO: add typings
// eslint-disable-next-line
const getNameComponent = (entity: any): ReactNode => {
  let nameNode

  switch (entity.type) {
    case 'Company':
      nameNode = (
        <Link to="/relationships/$id" params={{ id: entity.id.toString() }}>
          {entity.name}
        </Link>
      )
      break
    case 'Contact':
      nameNode = (
        <Link to="/contacts/$contactId" params={{ contactId: entity.id.toString() }}>
          {entity.name}
        </Link>
      )
      break
    case 'Vendor/Customer':
      nameNode = (
        <Link to={routes.bank.customerVendors.details} params={{ id: entity.id }}>
          {entity.name}
        </Link>
      )
      break
    default:
      if (entity.internalLicense) {
        const {
          internalLicense: { id }
        } = entity
        nameNode = (
          <Link to="/licenses/$licenseId" params={{ licenseId: id }}>
            {entity.name}
          </Link>
        )
      } else {
        nameNode = entity.name
      }
      break
  }

  return nameNode
}

export const columns = (): TableColumn<AdverseMediaDetailsType['relatedEntities'][0]>[] => [
  {
    title: 'Name',
    align: 'left',
    render: (item) => getNameComponent(item)
  },
  {
    title: 'Type',
    key: 'type',
    align: 'right'
  }
]
